import ConstraintTypesList from './ConstraintTypesList';
import './ConstraintTypesList.css';
export default ConstraintTypesList;
